import React from "react";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import Styles from "./styles";
import ActionPanel from "../ActionPanel";
import Input from "../Formsy/Input";
import FileInput from "../Formsy/FileInput";

class AddLayerPanel extends React.Component {
  constructor() {
    super();

    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.changed = false;
  }

  onValidSubmit(data) {
    this.props.onValidSubmit(data);
    this.reset();
  }

  onChange() {
    this.changed = true;
  }

  reset() {
    if (this.changed) {
      this.changed = false;
      this.form.reset();
    }
  }

  submit() {
    this.form.submit();
  }

  render() {
    const { ...actionPanelProps } = this.props;

    return (
      <ActionPanel
        title="Create new layer"
        wrapperStyle={Styles.wrapper}
        wrapperOpenStyle={Styles.wrapperOpen}
        style={Styles.contents}
        {...actionPanelProps}
      >
        <Formsy
          onChange={this.onChange}
          onValidSubmit={this.onValidSubmit}
          style={{ width: "100%" }}
          ref={component => {
            this.form = component;
          }}
        >
          <div style={{ padding: "0 10px" }}>
            <Input
              value=""
              forceBackground
              name="name"
              required
              placeholder="scene name"
            />
          </div>
          <FileInput multiple name="panorama" label="Add panorama (optional)" />
        </Formsy>
      </ActionPanel>
    );
  }
}

AddLayerPanel.propTypes = {
  isOpen: PropTypes.bool,
  reset: PropTypes.func,
  onValidSubmit: PropTypes.func
};

AddLayerPanel.defaultProps = {
  isOpen: false,
  reset: () => {},
  onValidSubmit: () => {}
};

export default AddLayerPanel;



// WEBPACK FOOTER //
// ./src/components/AddLayerPanel/index.js